import moment from 'moment';
import { transformTimelogsToEvents } from './events';

// Monday (ISO week) of the date, as the YYYY-MM-DD that /api/timelogs/week expects.
export const weekStartOf = (date) => moment(date).startOf('isoWeek').format('YYYY-MM-DD');

// Drafts the user is still editing do not exist in Zoho yet and must survive a merge.
const isLocalOnly = (ev) =>
  ev.approval_status === 'Marked' || (ev.logId && String(ev.logId).startsWith('temp-'));

const isProjectsLog = (ev) => ev.logId && String(ev.logId).startsWith('projects:');

// /api/timelogs/week answers [{ label, timelogs: [day] }], the same shape as /api/timelogs.
export function weekResponseToEvents(data) {
  const days = (data || []).flatMap(group => group.timelogs || []);
  return transformTimelogsToEvents({ timelogs: { date: days } });
}

// Replaces the Projects logs inside the week with the fresh ones, so a log created or
// deleted outside the calendar shows up correctly. People logs, drafts and other weeks stay.
export function mergeWeekIntoEvents(prev, freshEvents, weekStart) {
  const from = moment(weekStart, 'YYYY-MM-DD').startOf('day');
  const to = moment(from).add(7, 'days');
  const kept = prev.filter(ev =>
    isLocalOnly(ev) || !isProjectsLog(ev) || !moment(ev.start).isBetween(from, to, null, '[)'));
  return [...kept, ...freshEvents];
}
